import Render from 'common/Render';
import makeRoutes from './routes';
import _debug from 'debug';

const debug = _debug('app::catalog');

export function edit(ctx) {
  const code = ctx.params.code;
  debug(`Rendering catalog ${code}`);

  Render.render(store => makeRoutes(store, code));
}



// WEBPACK FOOTER //
// ./src/modules/catalog/index.js